import awsdk from 'awsdk';

// NONE
// MOBILE
// MULTIPLE
// PHONE
// WEB
// WEB_AND_PHONE
// WEB_SDK
// WEB_SDK_AND_PHONE
// KIOSK
// TELEMED

export const ConnectionType = awsdk.AWSDKConnectionType;
export type ConnectionType = typeof ConnectionType;
